import React from 'react';
import { useIntl } from 'react-intl';
import type { BetslipDefault } from '@gin-betting/betslip';
import { App } from '@gin-betting/core';
import cn from 'classnames';
import { map } from 'lodash';

import UserDevice from 'services/user-device';
import messages from '../../../messages';
import CheckListItem from './CheckListItem';

import './updatesSettings.scss';

interface Props {
    changeOddUpdateStatus: BetslipDefault['actions']['changeOddUpdateStatus'];
    activeOddUpdateStatus: App.OddUpdateStatus;
}

const SettingsPopup: React.FC<Props> = ({
    activeOddUpdateStatus,
    changeOddUpdateStatus,
}) => {
    const { formatMessage } = useIntl();

    return (
        <div
            styleName={cn('overlay', {
                'is-mobile': UserDevice.getInstance()?.isDeviceMobile(),
            })}
        >
            <div
                styleName="container"
                className="__app-SettingsPopup-container"
            >
                <div styleName="header" className="__app-SettingsPopup-header">
                    {formatMessage(messages.notificationSettingsTitle)}
                    <div styleName="description">
                        {formatMessage(messages.updatesSettingsDescription)}
                    </div>
                </div>

                {map(App.OddUpdateStatus, oddUpdateStatus => {
                    const isChecked = activeOddUpdateStatus === oddUpdateStatus;

                    const label = formatMessage(messages[oddUpdateStatus]);

                    return (
                        <CheckListItem
                            key={oddUpdateStatus}
                            changeOddUpdateStatus={changeOddUpdateStatus}
                            oddUpdateStatus={oddUpdateStatus}
                            label={label}
                            isChecked={isChecked}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default SettingsPopup;
